import script from "./noticeModel.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeModel.vue?vue&type=script&setup=true&lang=js"

import "./noticeModel.vue?vue&type=style&index=0&id=050f5245&lang=less&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-050f5245"]])

export default __exports__